import ChatNightMode from './ChatNightMode.jsx';
import { connect } from 'react-redux';

import { request as setChatNightMode } from '../../modules/trader-chat/actions/disable-chat';
import { request as getChatNightMode } from '../../modules/trader-chat/actions/get-disable-chat';

import decorate from '../../utils/decorate';
import { Map } from 'immutable';

function mapStateToProps(state) {
    return {
        chatNightMode: state.chats.get('chatNightMode', Map())
    };
}

function mapDispatchToProps(dispatch) {
    return {
        onSetChatNightModeRequest: (data) => dispatch(setChatNightMode(data)),
        onGetChatNightMode: () => dispatch(getChatNightMode())
    };
}

export default decorate(
    connect(mapStateToProps, mapDispatchToProps),
    ChatNightMode
);
